import AnimatedCar from "@/components/AnimatedMap/Car";
import MobileMap from "@/components/AnimatedMap/MobileMap";
import { Box, CardMedia } from "@mui/material";
import map_url from "@/assets/images/why-trackmate/map.png"
import { animated, useSpring } from "react-spring";
import { transitionOptions, mapSizes } from "./mockData";
import useResponsive from "@/hooks/useResponsive";
import { useMemo } from "react";
import { getMapOptions } from "./utils";
import { getSize } from "../../utils";

const AnimatedMobileMap = () => {
  const isTablet = useResponsive("between", "md", "lg");
  const sizes = useMemo(() => isTablet ? mapSizes.md : mapSizes.lg, [isTablet]);
  const options = useMemo(() => {
    const getWidth = getSize(mapSizes.lg.width / sizes.width);
    const getHeight = getSize(mapSizes.lg.height / sizes.height);
    return getMapOptions(getWidth, getHeight);
  }, [sizes]);
  const [styles] = useSpring(() => transitionOptions, []);
  const [mapStyles] = useSpring(() => options.map, []);
  const Animated = animated(({ children, ...props }) => (
    <MobileMap
      {...props}
      sx={{
        width: "100%",
        height: "100%",
        padding: "6px"
      }}
    >
      {children}
    </MobileMap>  
  ));
  const AnimatedMap = animated((props) => (
    <Box
      {...props}
      sx={{
        width: { md: "1024px", lg: "1280px" },
        height: { md: "1024px", lg: "1280px" },
        position: "absolute"
      }}
    >
      <CardMedia 
        component="img"
        image={map_url} 
        width="100%"
        height="100%"
      />
      <AnimatedCar options={options.car} />
    </Box>
  ))

  return (
    <Animated style={styles}>
      <AnimatedMap style={mapStyles} />
    </Animated>
  )
};

export default AnimatedMobileMap;